var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widget_settings.powered_by.text != null)?_c('a',{staticStyle:{"margin":"10px 0"},attrs:{"href":_vm.widget_settings.powered_by.website,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.getPowered())}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }